
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_32355","data-name":"Group 32355","transform":"translate(-.5 -3.5)"}},[_c('g',{attrs:{"id":"Group_32291","data-name":"Group 32291","transform":"translate(0 3)","fill":"none"}},[_c('rect',{attrs:{"id":"Rectangle_9360","data-name":"Rectangle 9360","width":"19","height":"19","transform":"translate(.5 .5)"}}),_c('path',{attrs:{"id":"Rectangle_9361","data-name":"Rectangle 9361","d":"M3.39 4.009h13.219a1.935 1.935 0 011.935 1.935v8.111a1.935 1.935 0 01-1.935 1.935H3.39a1.934 1.934 0 01-1.934-1.934V5.943A1.934 1.934 0 013.39 4.009z","stroke":"#5a677d","stroke-width":"1"}}),_c('g',{attrs:{"id":"Group_32299","data-name":"Group 32299","transform":"translate(.693)","stroke":"#5a677d","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.1"}},[_c('g',{attrs:{"id":"Group_32297","data-name":"Group 32297","transform":"translate(2.9 7.297)"}},[_c('line',{attrs:{"id":"Line_854","data-name":"Line 854","x2":"2.77","y2":"2.764","transform":"translate(0 2.763)"}}),_c('line',{attrs:{"id":"Line_855","data-name":"Line 855","x2":"5","transform":"translate(0 2.764)"}}),_c('line',{attrs:{"id":"Line_856","data-name":"Line 856","x1":"2.77","y2":"2.764"}})]),_c('g',{attrs:{"id":"Group_32298","data-name":"Group 32298","transform":"rotate(180 7.856 6.412)"}},[_c('line',{attrs:{"id":"Line_854-2","data-name":"Line 854","x2":"2.77","y2":"2.764","transform":"translate(0 2.763)"}}),_c('line',{attrs:{"id":"Line_855-2","data-name":"Line 855","x2":"5","transform":"translate(0 2.764)"}}),_c('line',{attrs:{"id":"Line_856-2","data-name":"Line 856","x1":"2.77","y2":"2.764"}})])])])])])
          )
        }
      }
    